
import { Component, Mixins } from 'vue-property-decorator';
import { eRulesDialogContentStatus, iAreaBackup } from '@/interface/backup-tactics';

import { getAreaBackList, getBackupDetail, getBackupSelectList } from '@/api/backup-tactics';
import { GameArea } from '@/mixins/game_area';
import { PageQuery } from '@/mixins/page_query';
import { toast } from '@/utils/common';
import EditBackupTactics from './_EditBackupTactics.vue';
import { type } from 'os';
@Component({
  components: {
    EditBackupTactics,
  },
})
export default class DeviceTable extends Mixins(GameArea, PageQuery) {
  private dialogVisible = false;
  private rulesDialogStatus = eRulesDialogContentStatus.INFO;
  private selectList: any = [];
  private query = {
    search: '',
    regionid: 0,
    ispublic: 0,
  };
  editor: boolean = false;
  private detail: iAreaBackup = {
    id: 0,
    name: '',
    city: '',
    region_id: 0,
    region_name: '',
    is_public: false,
    policy_id: 0,
    policy_name: '',
    policy_type: 0,
  };
  private detailId: number = 0; //更改时候策略ID
  private multipleSelection!: iAreaBackup[];
  private tableList: iAreaBackup[] = [];
  private ids: any[] = [];
  private idsStr: string = '';
  private defalutModel: any = {};
  private isShowUpdataTacitcs: boolean = false;
  //加载数据状态
  loading: boolean = false;
  goList() {
    console.log('goinfo1');
    this.$emit('goList');
  }

  closeDialog() {
    this.dialogVisible = false;
  }
  handlerSuccess() {
    toast('操作成功！');
    this.closeDialog();
    this.getAreaBackList();
  }

  showEdit(row: iAreaBackup) {
    // console.log('willEdit👩🏻👱‍♂️', row);
    const { policy_id, policy_type, id } = row;
    this.detailId = policy_id;
    this.ids = [{ area_id: id, unbind_policy_id: policy_id, unbind_policy_type: policy_type }];
    this.idsStr = row.name;
    this.dialogVisible = true;
    // this.rulesDialogStatus = eRulesDialogContentStatus.UPDATATACTICS;
    this.isShowUpdataTacitcs = true;
  }

  async showDetail(id: number) {
    try {
      this.detailId = id;
      this.dialogVisible = true;
      this.isShowUpdataTacitcs = false;
    } catch (err) {
      console.log(err);
    }
  }
  handleSelectionChange(vals: iAreaBackup[]) {
    this.multipleSelection = vals;
    if (vals.length > 0) {
      this.ids = [];
      this.idsStr = '';
      vals.forEach((el: iAreaBackup, index: number) => {
        const { policy_id, policy_type, id, name } = el;
        this.ids.push({ area_id: id, unbind_policy_id: policy_id, unbind_policy_type: policy_type });
        if (index != 0) {
          this.idsStr += ';';
        }
        this.idsStr += name;
      });
    } else if (vals.length === 0) {
      this.ids = [];
      this.idsStr = '';
    }
    // console.log(this.ids);
  }
  toggleSelection(rows: any, column: any) {
    if (column.label != '操作') {
      (this.$refs['selectTableDate'] as any).toggleRowSelection(rows);
    }
  }
  handlerUpdate() {
    if (this.ids.length <= 0) {
      toast('请选择您要操作的数据', 'error');
      return false;
    }
    this.detailId = 0;
    this.dialogVisible = true;
    this.isShowUpdataTacitcs = true;
  }
  /**
   * 改变选择
   */
  changeSelect() {
    this.searchList();
  }
  searchList() {
    this.page_query.page = 1;
    this.getAreaBackList();
  }

  async getAreaBackList() {
    this.loading = true;
    try {
      const res = await getAreaBackList({ ...this.query, ...this.page_query });
      // console.log(res, 111);
      this.loading = false;
      if (res) {
        this.tableList = res.data.list;
        this.total = res.data.total;
      }
    } catch (error) {
      this.loading = false;
      console.log(error);
    }
  }

  mounted() {
    this.pageFn = this.getAreaBackList;
    this.getAreaBackList();
    this.getSelectList();
  }
  async getSelectList() {
    try {
      const res = await getBackupSelectList();

      if (res.code == 0) {
        this.selectList = res.data;
        this.selectList.unshift({ id: 0, name: '请选择备机策略' });
      }
    } catch (err) {
      console.log(err);
    }
  }
}
